module.exports = __webpack_public_path__ + "static/img/android.dd709a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/android.png
// module id = KUcA
// module chunks = 1